// extracted by mini-css-extract-plugin
export default {"heading":"fy-z","corrected":"gy-z","redirectVerbiageContainer":"hy-z","redirectVerbiageText":"iy-z"};